// removed by extract-text-webpack-plugin
module.exports = {"App":"_2W_qtC-edypTmoeYQWiJkT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Econom/style.css
// module id = 276
// module chunks = 0